import { Injectable } from '@angular/core';
import { Network } from '../model/network';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class NetworkService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    

    getAllNetworks() 
    {
      return this._restClientService.load<Network[]>('network/get');
    }
    
    getNetworkById(networkId){
      return this._restClientService.load<Network>('network/get/'+networkId);
    }
      
    putNetwork(network: Network) {
      return  this._restClientService.put<Network>(`network/update`, network);
    }
      
    postNetwork(network: Network) {
      return  this._restClientService.save<Network>('network/add', network);
    }
    
    deleteNetwork(networkId){
      return  this._restClientService.delete<void>('network/delete/'+networkId);
    }




}      

    